<template>
  <div class="event-list">
    <div v-if="innerLoading" class="loader">Идёт загрузка...</div>
    <div v-else>
      <h2>Выберите событие</h2>
      <div class="events">
        <div
          v-for="(eventData, eventName) in events"
          :key="eventName"
          @click="$emit('select', eventName)"
          class="event-card"
        >
          <h3>{{ eventName }}</h3>
          <p>{{ Object.keys(eventData.participants).length }} номинаций</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { data: Object },
  data: () => ({ innerLoading: true }),
  computed: {
    events() { return this.data || {} }
  },
  mounted() {
    setTimeout(() => this.innerLoading = false, 300)
  }
}
</script>

<style scoped>
.event-list { padding: 20px; max-width: 600px; margin: 0 auto; }
.event-card { background: white; padding: 20px; margin: 12px 0; border-radius: 12px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); cursor: pointer; }
.event-card:hover { transform: translateY(-3px); }
</style>